import { DispositionRecommendedAction, PathwayStatus, RuntimeOrderStatus_Enum } from '@app/advisor-shared';
import { ModuleFE_Advisor_Action, ModuleFE_Advisor_Resource, ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { ResourceType_Consultations, ResourceType_EKG, ResourceType_Imaging, ResourceType_Laboratory } from '@app/hcs-shared';
import { _keys, MUSTNeverHappenException } from '@nu-art/ts-common';
const orderPriority = [ResourceType_Consultations, ResourceType_EKG, ResourceType_Laboratory, ResourceType_Imaging];
export const getProtocolActions = (protocol, onlyRecommendedOrders = false) => {
    let orders = [];
    let groups = [];
    let disposition = [];
    //Collect all orders that are related to the protocol
    const runtimeOrders = ModuleFE_RuntimeOrder.cache.filter(rtOrder => {
        if (onlyRecommendedOrders && rtOrder.orderStatus !== RuntimeOrderStatus_Enum.RECOMMENDED)
            return false;
        if (rtOrder.orderStatus === RuntimeOrderStatus_Enum.RESULTED || rtOrder.orderStatus === RuntimeOrderStatus_Enum.COMPLETED)
            return false;
        // Filter out rejected orders
        if (rtOrder.extraMetadata?.rejected)
            return false;
        const protocolIds = _keys(rtOrder.protocolMapping ?? {});
        return protocolIds.includes(protocol.pathwayId);
    });
    //Group orders
    runtimeOrders.forEach(rtOrder => {
        const groupIds = rtOrder.protocolMapping[protocol.pathwayId];
        //Don't group pending orders
        if (!groupIds?.length || rtOrder.orderStatus === RuntimeOrderStatus_Enum.PENDING)
            return orders.push(rtOrder);
        groupIds.forEach(groupId => {
            let group = groups.find(group => group.groupId === groupId);
            if (!group) {
                group = { groupId, runtimeOrders: [] };
                groups.push(group);
            }
            group.runtimeOrders.push(rtOrder);
        });
    });
    //Disband groups with single orders
    groups = groups.filter(group => {
        if (group.runtimeOrders.length > 1)
            return true;
        orders.push(...group.runtimeOrders);
        return false;
    });
    //Sort orders
    orders = orders.sort((rtOrderA, rtOrderB) => {
        const orderA = ModuleFE_Advisor_Action.cache.unique(rtOrderA.orderId);
        const orderB = ModuleFE_Advisor_Action.cache.unique(rtOrderB.orderId);
        if (!orderA)
            throw new MUSTNeverHappenException(`Could not get order for id ${rtOrderA.orderId}`);
        if (!orderB)
            throw new MUSTNeverHappenException(`Could not get order for id ${rtOrderB.orderId}`);
        if (orderA.subType === 'treatment')
            return 1;
        if (orderB.subType === 'treatment')
            return -1;
        const resourceA = ModuleFE_Advisor_Resource.cache.unique(orderA.resourceId);
        const resourceB = ModuleFE_Advisor_Resource.cache.unique(orderB.resourceId);
        if (!resourceA && !resourceB)
            return 0;
        if (!resourceA)
            return 1;
        if (!resourceB)
            return -1;
        const indexA = orderPriority.indexOf(resourceA.type);
        const indexB = orderPriority.indexOf(resourceB.type);
        if (resourceA.label === ResourceType_EKG) {
            return indexB === 0 ? 1 : -1;
        }
        if (resourceB.label === ResourceType_EKG) {
            return indexA === 0 ? -1 : 1;
        }
        if (indexA === -1)
            return 1;
        if (indexB === -1)
            return -1;
        return indexA - indexB;
    });
    //Infer disposition
    if (protocol.status === PathwayStatus.REACHED_ADMIT)
        disposition = [DispositionRecommendedAction.ADMIT];
    else if (protocol.status === PathwayStatus.REACHED_DISCHARGE)
        disposition = [DispositionRecommendedAction.DISCHARGE];
    return { orders, groups, disposition };
};
//# sourceMappingURL=get-protocol-actions.js.map